import { I18nComponente } from "@/types/gerais"

export const OSelecionarMembrosProjetoi18n: I18nComponente = {
  "pt-BR": {
    profissionais: "profissionais",
    emailNaoInformado: "email não informado",
    codigo: "código",
    categoria: "categoria",
    selecionarCategoria: "selecionar categoria",
    adicionar: "adicionar",
    membros: "membros",
    cancelar: "cancelar",
    pesquisarPorNomeDoProfissional: "pesquisar por nome do profissional",
    pesquisarPorCodigoDoProfissional: "pesquisar por código do profissional",
    limpar: "Limpar",
    aplicar: "Aplicar",
  },
  "es-CO": {
    profissionais: "profesionales",
    emailNaoInformado: "correo electrónico no informado",
    codigo: "código",
    categoria: "categoría",
    selecionarCategoria: "seleccionar categoría",
    adicionar: "añadir",
    membros: "miembros",
    cancelar: "cancelar",
    pesquisarPorNomeDoProfissional: "buscar por nombre del profesional",
    pesquisarPorCodigoDoProfissional: "buscar por código del profesional",
    limpar: "Borrar",
    aplicar: "Aplicar",
  }
}
